import React, { ReactElement, useState, useEffect, useRef } from "react";

interface Webinar {
  author?: string;
  mp4?: string;
  summary?: string;
  tags?: string[];
  title?: string;
}

type WebinarStyleObject = {
  [key: string]: React.CSSProperties;
};

interface WebinarProps {
  categoryFilters: string[];
  handleToggleWebinar: any;
  searchTerm: string;
  sortBy: string;
  webinar: any;
  isMobileView: boolean;
  isTabletView: boolean;
  isDesktopView: boolean;
}

export const WebinarTile: React.FC<WebinarProps> = ({
  categoryFilters,
  searchTerm,
  sortBy,
  webinar,
  isMobileView,
  isTabletView,
  isDesktopView,
}) => {
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const handleClick = () => {
    const anchor = document.createElement("a");
    anchor.href = downloadUrl;
    anchor.target = "_blank"; // Open the link in a new tab (optional)
    anchor.download = "video.mp4"; // Specify the filename for the downloaded file (optional)

    // anchor.click();
    setIsVisible(true);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 } // Adjust threshold value as needed
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  const { fields: { Summary, Title, Author0 }, downloadUrl, webUrl } = webinar;

  const WebinarStyles: WebinarStyleObject = {
    mobileViewWrapper: {
      display: "flex",
      flexDirection: "column",
      marginBottom: "1em",
      marginTop: "1em",
      overflow: "hidden",
    },
    tabletViewWrapper: {
      display: "flex",
      flexDirection: "row",
      height: "12em",
      marginBottom: "1em",
      marginTop: "1em",
      overflow: "hidden",
    },
    desktopViewWrapper: {
      display: "flex",
      flexDirection: "row",
      height: "12em",
      marginBottom: "1em",
      marginTop: "1em",
      overflow: "hidden",
    },
    videoContainer: {
      background: "linear-gradient(to bottom right, black, darkgrey)",
      height: "180px",
      width: "100%",
      cursor: "pointer",
    },
    video: {
      width: "100%",
      height: "180px",
    },
    contentContainer: {
      paddingLeft: 10,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
    },
    title: {
      fontWeight: 600,
    },
    author: {
      fontWeight: 600,
      marginBottom: 5,
    },
    summary: {
      marginBottom: 5,
    },
    hr: {
      border: "1px solid #ccc",
    },
  };

  return (
    <>
      {/* Mobile View */}
      {isMobileView && (
        <div style={WebinarStyles.mobileViewWrapper}>
          <div
            ref={videoRef}
            style={WebinarStyles.videoContainer}
            onClick={handleClick}
          >
            {isVisible && (
              <video style={WebinarStyles.video} controls>
                <source src={downloadUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
          <div style={WebinarStyles.contentContainer}>
            <div>
              <h3 style={WebinarStyles.title}>{Title}</h3>
              <p style={WebinarStyles.author}>By: {Author0}</p>
            </div>
          </div>
        </div>
      )}

      {/* Tablet View */}
      {isTabletView && (
        <div style={WebinarStyles.tabletViewWrapper}>
          <div
            ref={videoRef}
            style={{
              ...WebinarStyles.videoContainer,
              flexBasis: "40%",
            }}
            onClick={handleClick}
          >
            {isVisible && (
              <video style={WebinarStyles.video} controls>
                <source src={downloadUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
          <div
            style={{
              ...WebinarStyles.contentContainer,
              flexBasis: "60%",
            }}
          >
            <div>
              <h3 style={WebinarStyles.title}>{Title}</h3>
              <p style={WebinarStyles.author}>By: {Author0}</p>
            </div>
            <div>
              <p style={WebinarStyles.summary}>{Summary}</p>
            </div>
          </div>
        </div>
      )}

      {/* Desktop View */}
      {isDesktopView && (
        <div style={WebinarStyles.desktopViewWrapper}>
          <div
            ref={videoRef}
            style={{
              ...WebinarStyles.videoContainer,
              flexBasis: "25%",
            }}
            onClick={handleClick}
          >
            {isVisible && (
              <video style={WebinarStyles.video} controls>
                <source src={downloadUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
          <div
            style={{
              ...WebinarStyles.contentContainer,
              flexBasis: "75%",
            }}
          >
            <div>
              <h3 style={WebinarStyles.title}>{Title}</h3>
              <p style={WebinarStyles.author}>By: {Author0}</p>
            </div>
            <div>
              <p style={WebinarStyles.summary}>{Summary}</p>
            </div>
          </div>
        </div>
      )}
      <hr style={WebinarStyles.hr} />
    </>
  );
};
